import { Theme } from '@mui/material';

export const getBorderColor = (isDragging: boolean, ComponentsLength: number) => {
  if (ComponentsLength > 0) return;

  return (t: Theme) => isDragging ? `2px dashed ${t.palette.primary.main}` : `2px dashed ${t.palette.divider}`;
};